import React from 'react';
import { useAppMeta } from "hooks";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import LegForm from "./LegComponents/LegForm";

import {
  useGetLegDetailQuery,
  useUpdateLegMutation
} from "store/services/legApi"; 

const LegEditScreen = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Leg", path: "/app/crm/leg/list" },
    { title: "Edit Leg" },
  ];

  // RTK Query to fetch Leg details
  const {
    data: legDetail,
    isLoading: loadingLeg,
    error,
  } = useGetLegDetailQuery(id);

  const [updateLeg, { isLoading: updatingLeg }] = useUpdateLegMutation();

  // methods
  const handleUpdateLeg = async (data) => {
    const _payload = data;

    delete _payload.someField;

    try {
      await updateLeg({ ..._payload }).unwrap();
      toast.success("Leg successfully updated!");
      navigate(`/app/crm/leg/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Leg!"
      );
    }
  };

  useAppMeta("Edit Leg");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingLeg || updatingLeg}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <LegForm
          isBusy={loadingLeg || updatingLeg}
          legDetail={legDetail}
          onSubmit={handleUpdateLeg}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default LegEditScreen;
